module.exports = __webpack_public_path__ + "img/background.3040f39a.svg";